// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"247e2e4b","453":"016d656c","455":"e519f890","977":"b3b710f8"}[chunkId] + ".chunk.js";
};